export default "__VITE_ASSET__DtgQWwYz__"